/**
* Small library for creating qos metrics
**/

// Module imports
var _ = require('lodash'),
  log = require('./logger').getLoggerInstance('Base.PerformanceMetrics'),
  cache = require('../models/cache');

// local imports
var perf = cache.window.performance,
  methods;

methods = {
  mark: function (tag) {
    perf.mark(tag);
  },
  measure: function (key, from, to) {
    perf.measure(key, from, to);
  },
  getElapsed: function (key) {
    var items = perf.getEntriesByType('measure'),
      report;

    if (items) {
      report = _.find(items, function (i) {
        return i.name === key;
      });

      if (report) {
        return report.duration;
      } else {
        return -1;
      }
    }

    return -1;
  },
  refresh: function () {
    perf = cache.window.performance;
    methods.supportCheck();
  },
  getMatchingResourceDuration: function (nameToMatch) {
    var matchingItem;

    try {
      var items = perf.getEntriesByType('resource');

      if (items) {
        matchingItem = _.find(items, function (item) {
          return item.name.indexOf(nameToMatch) > -1;
        });
      }
    }
    catch (e) {
      log.error('Get matching resource duration for [' + nameToMatch + '] resulted in an exception: ' + e);
    }
    return matchingItem;
  },
  getAllMatchingResourceDurations: function (nameToMatch) {
    var matchingItems = [];

    try {
      var items = perf.getEntriesByType('resource');

      if (items) {
        _.each(items, function (item) {
          if (item.name.indexOf(nameToMatch) > -1) {
            matchingItems.push(item);
          }
        });
      }
    }
    catch (e) {
      log.error('Get all matching resource durations for [' + nameToMatch + '] resulted in an exception: ' + e);
    }
    return matchingItems;
  },
  supportCheck: function () {
    if (perf === undefined) {
      perf = {
        mark: function () {
          // add function to prevent exception thrown when attempted to be used
        },
        measure: function () {
          // add function to prevent exception thrown when attempted to be used
        },
        getEntriesByType: function () {
          // add function to prevent exception thrown when attempted to be used
        },
      };
    }
  }
};

methods.supportCheck();

module.exports = methods;



//////////////////
// WEBPACK FOOTER
// ./libraries/performanceMetrics.js
// module id = 62
// module chunks = 0 5 20